module.exports = __webpack_public_path__ + "static/media/aragon80.e84b88f8.jpg";